export default async function dataUrlToBlob(dataURL: string) {
  const res = await fetch(dataURL);
  const blob = await res.blob();
  return blob;
}